import { createSlice } from "@reduxjs/toolkit";

const initialMediaState = {
  mediaList: [],
  listLoading: false,
  error: null,
};

export const callTypes = {
  list: "list",
};

export const mediaSlice = createSlice({
  name: "Media",
  initialState: initialMediaState,
  reducers: {
    catchError: (state, action) => {
      state.error = ` ${action.payload.error?.response?.data.message}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        default:
          break;
      }
    },
    mediaFetched: (state, action) => {
      state.mediaList = action.payload.mediaList;
      state.listLoading = false;
      state.error = null;
    },
  },
});
